import axios from 'axios'

import {
  BasicUrls
} from "./basicurls.js";

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: BasicUrls,
  // 超时
  timeout: 10000
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  // var t = sStorage.get('userInfo');
  // if (t) {
  //   config.headers['Authorization'] = t[0]["token"];
  // }
  // console.log(config);
  return config
}, error => {
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    // const code = res.data.code || 200;
    // let {
    //   code
    // } = res.data;
    // if (code == 0) {
    //   Message.error(res.data.message);
    //   sStorage.remove()
    //   router.push("/login");
    //   return null;
    // }
    
    return res.data
      
    // // 获取错误信息
    // const msg = res.data.msg
    // // 二进制数据则直接返回
    // if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    //   return res.data
    // }
    // if (code !== 200) {
    //   return Promise.reject('error')
    // } else {
    // return res.data
    // }
  },
  error => {
    // let {
    //   message,
    //   code
    // } = error;
    return Promise.reject(error)
  }
) 

export default service
